import get from 'lodash/get'

export const transformData = (data = {}, options = {}) => {
	const { queryFieldExtract } = options
	const appFieldList = ['cashAssist', 'fakturaAssist', 'rezeptAssist', 'reports']
	const queryFields = Object.keys(data)
	let applicationField = null
	const hasAppField = queryFields.length && Object.keys(data).every(field => {
		const isAppField = appFieldList.includes(field)
		if(isAppField) {
			applicationField = field
		}
		return field === '__typename' || isAppField
	})
	const queryField = hasAppField ? Object.keys(data?.[applicationField] || {})[0] : queryFields[0]

	let outData = (hasAppField ? get(data, applicationField) : data) || {}
	outData = queryFieldExtract ? get(outData, queryField) : outData
	return {
		data: outData,
		appField: hasAppField ? applicationField : null,
		queryField: queryField,
		appTypename: hasAppField ? data?.[applicationField]?.__typename : null
	}
}

